var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"w-600 text-uppercase font-12 text-subdued"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('div',{staticClass:"font-14 w-600 text-default q-mt-sm"},[_vm._v(" "+_vm._s(_vm.subtitle)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }